import axios from 'axios';
import getCookie from '#/utils/cookies.js';
import { getBaseUrlWithCustomerPrefix } from './serviceCommons';

const BASE_URL = getBaseUrlWithCustomerPrefix(process.env.REACT_APP_URL_API);
const LIST_SIZE = 10;

export const fetchFilters = async () => {
  return await axios({
    method: 'GET',
    url: `${BASE_URL}/dashboard/dashboards/userfilters`,
    headers: { Authorization: `Bearer ${getCookie('access_token')}` },
  });
};

export const fetchClientFilter = async (value, page = 0, isPaged = false) => {
  return await axios({
    method: 'POST',
    url: `${BASE_URL}/core/clients/allfilter/notinactiveworkplace${!isPaged ? `?page=${page}&size=${LIST_SIZE}&sort=name,asc` : 'notpaged'}`,
    headers: { Authorization: `Bearer ${getCookie('access_token')}` },
    data: {
      type: 'value',
      value: value === undefined || value === null ? null : value,
    },
  });
};

export const fetchWorkplaceFilter = async (value, page = 0, isPaged = false) => {
  return await axios({
    method: 'POST',
    url: `${BASE_URL}/core/workplaces/allfilter/conjugated${!isPaged ? `?page=${page}&size=${LIST_SIZE}&sort=name,asc` : 'notpaged'}`,
    headers: {
      Authorization: `Bearer ${getCookie('access_token')}`,
      'Content-Type': 'application/json;charset=UTF-8',
    },
    data: value === undefined || value === null ? null : value,
  });
};

export const fetchPersonFilter = async (value, page = 0, isPaged = false) => {
  return await axios({
    method: 'GET',
    url: `${BASE_URL}/core/persons/allactive/${value}/${!isPaged ? `?page=${page}&size=${LIST_SIZE}&sort=id,asc` : 'notpaged'}`,
    headers: {
      Authorization: `Bearer ${getCookie('access_token')}`,
      'Content-Type': 'application/json;charset=UTF-8',
    },
    data: value === undefined || value === null ? null : value,
  });
};

export const fetchAreaFilter = async (value, page = 0, isPaged = false) => {
  return await axios({
    method: 'GET',
    url: `${BASE_URL}/core/areas/all/${value}/${!isPaged ? `?page=${page}&size=${LIST_SIZE}&sort=id,asc` : 'notpaged'}`,
    headers: {
      Authorization: `Bearer ${getCookie('access_token')}`,
      'Content-Type': 'application/json;charset=UTF-8',
    },
    data: value === undefined || value === null ? null : value,
  });
};

export const fetchApprovalReasonFilter = async (value, page = 0, isPaged = false) => {
  return await axios({
    method: 'GET',
    url: `${BASE_URL}/core/approvalreasons/all/${value}/${!isPaged ? `?page=${page}&size=${LIST_SIZE}&sort=id,asc` : 'notpaged'}`,
    headers: {
      Authorization: `Bearer ${getCookie('access_token')}`,
      'Content-Type': 'application/json;charset=UTF-8',
    },
    data: value === undefined || value === null ? null : value,
  });
};

export const fetchBusinessUnitFilter = async (value, page = 0, isPaged = false) => {
  return await axios({
    method: 'POST',
    url: `${BASE_URL}/core/businessunits/allfilter${!isPaged ? `?page=${page}&size=${LIST_SIZE}&sort=name,asc` : 'notpaged'}`,
    headers: { Authorization: `Bearer ${getCookie('access_token')}` },
    data: {
      type: 'value',
      value: value === undefined || value === null ? null : value,
    },
  });
};

export const fetchCompaniesFilter = async (value, page = 0, isPaged = false) => {
  return await axios({
    method: 'POST',
    url: `${BASE_URL}/core/companies/allfilter${!isPaged ? `?page=${page}&size=${LIST_SIZE}&sort=fantasyName,asc` : 'notpaged'}`,
    headers: { Authorization: `Bearer ${getCookie('access_token')}` },
    data: {
      type: 'value',
      value: value === undefined || value === null ? null : value,
    },
  });
};

export const fetchTimeTrackingTypesFilter = async (value) => {
  return await axios({
    method: 'GET',
    url: `${BASE_URL}/time-tracking/timetrackingtypes/allnotpageabletranslated`,
    headers: { Authorization: `Bearer ${getCookie('access_token')}` },
    data: {
      type: 'value',
      value: value === undefined || value === null ? null : value,
    },
  });
};

export const fetchAbsenceSituationStatic = async (value) => {
  return await axios({
    method: 'GET',
    url: `${BASE_URL}/core/absencesituations/nopageable/active`,
    headers: { Authorization: `Bearer ${getCookie('access_token')}` },
    data: {
      type: 'value',
      value: value === undefined || value === null ? null : value,
    },
  });
};

export const fetchServiceTypesFilter = async (value, page = 0, isPaged = false) => {
  return await axios({
    method: 'GET',
    url: `${BASE_URL}/core/servicetypes/allfilter${!isPaged ? `?page=${page}&size=${LIST_SIZE}&sort=name,asc` : 'notpaged'}`,
    headers: { Authorization: `Bearer ${getCookie('access_token')}` },
    data: {
      type: 'value',
      value: value === undefined || value === null ? null : value,
    },
  });
};

export const fetchAbsenceSituationFilter = async (value, page = 0, isPaged = false) => {
  return await axios({
    method: 'POST',
    url: `${BASE_URL}/core/absencesituations/allfilter${!isPaged ? `?page=${page}&size=${LIST_SIZE}&sort=name,asc` : 'notpaged'}`,
    headers: { Authorization: `Bearer ${getCookie('access_token')}` },
    data: {
      type: 'value',
      value: value === undefined || value === null ? null : value,
    },
  });
};

export const fetchEventsFilter = async (value) => {
  return await axios({
    method: 'GET',
    url: `${BASE_URL}/core/events/all`,
    headers: { Authorization: `Bearer ${getCookie('access_token')}` },
    data: {
      type: 'value',
      value: value === undefined || value === null ? null : value,
    },
  });
};

export const fetchOccurrenceReasonFilter = async (value, page = 0, isPaged = false) => {
  return await axios({
    method: 'GET',
    url: `${BASE_URL}/core/occurrencereasons/allactive${!isPaged ? `?page=${page}&size=${LIST_SIZE}&sort=name,asc` : 'notpaged'}`,
    headers: { Authorization: `Bearer ${getCookie('access_token')}` },
    data: {
      type: 'value',
      value: value === undefined || value === null ? null : value,
    },
  });
};